import * as React from 'react';
import './index.css';

interface IProps {
  title: string;
  clickBack: Function;
  backgroundColor?: string;
}

export default class NavigationBar extends React.Component<IProps, any> {
  render() {
    const { title, clickBack, backgroundColor = '#FFFFFF' } = this.props;
    return (
      <view style={{ width: Mach.env.screenWidth, paddingTop: Mach.env.statusBarHeight, backgroundColor }}>
        <view className="navi-container" style={{ backgroundColor, height: Mach.env.navigationBarHeight }}>
          <view className="navi-back-icon-wrap" onClick={() => { clickBack(); }}>
            <image className="navi-back-icon" src="assets://review/icon_review_navi_back.png" autoRTL />
          </view>
          <text className="navi-title-text" content={title} />
        </view>
      </view>
    );
  }
}
